// extracted by mini-css-extract-plugin
export var box = "_47-0";
export var check = "_47-1";
export var checkboxButton = "_47-6";
export var checkboxGroup = "_47-5";
export var disabled = "_47-7";
export var ghost = "_47-9";
export var input = "_47-2";
export var label = "_47-4";
export var normal = "_47-8";
export var uncheck = "_47-3";